<template>
  <div
    :key="mediaId"
    class="bk-media-library-items-item"
    :class="{ 'bk-is-selected': isSelected }"
    :data-sortli-id="'media_library_' + mediaId"
    data-element-type="media_library"
    :data-item-bundle="targetBundles[0]"
    :data-media-id="mediaId"
    :data-media-bundle="mediaBundle"
  >
    <div class="bk-media-library-items-item-box">
      <label @click.stop>
        <input v-model="selected" type="checkbox" :value="mediaId" />
      </label>
      <div class="bk-media-library-items-item-image">
        <img :src="thumbnail" />
      </div>
    </div>
    <div class="bk-media-library-items-item-text">
      <h3>{{ label }}</h3>
      <p>{{ context }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from "#imports";
const props = defineProps({
  mediaId: { type: String, required: true },
  label: { type: String, required: true },
  context: { type: String, required: true },
  targetBundles: { type: Array, required: true },
  thumbnail: { type: String, required: false },
  icon: { type: null, required: false },
  mediaBundle: { type: String, required: false }
});
const selected = defineModel({ type: Array });
const isSelected = computed(() => selected.value?.includes(props.mediaId));
</script>
